import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { CustomTranslationsService, STATE } from 'src/app/operational-data-common/translations';

import { InstallationFeaturesStore } from '@store';
import {
  DcSensorValueProperties,
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  IsActiveProperty,
  LagDeviceModulationProperties,
} from '@vi-iot/client';
import { SUFFIX } from '../../../../shared/common/units';

@Component({
  selector: 'app-lag-device-details-overlay',
  templateUrl: './lag-device-details-overlay.component.html',
  styleUrls: ['./lag-device-details-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LagDeviceDetailsOverlayComponent implements OnInit {
  readonly featurePropertyKey = FeaturePropertyKey;
  supplyTemperature$: Observable<Feature<DcSensorValueProperties, never>>;
  burnerStatus$: Observable<Feature<IsActiveProperty, never>>;
  burnerModulation$: Observable<Feature<LagDeviceModulationProperties, never>>;

  STATE = STATE;
  SUFFIX = SUFFIX;

  @Input() lagDeviceIdx: string;

  constructor(
    private installationFeaturesStore: InstallationFeaturesStore,
    protected customTranslationsService: CustomTranslationsService
  ) {}

  ngOnInit(): void {
    this.supplyTemperature$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.cascadeLagDeviceSupplyTemperature(this.lagDeviceIdx)
    );
    this.burnerStatus$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.cascadeLagDeviceBurnerStatus(this.lagDeviceIdx)
    );
    this.burnerModulation$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.cascadeLagDeviceBurnerModulation(this.lagDeviceIdx)
    );
  }
}
